import { Cart, PolicyCartInput } from '../types';
import { CartPolicyMeta, CartPolicyResult, TaggedPolicy } from './types';

export function runPolicies(
  policies: TaggedPolicy[],
  input: PolicyCartInput,
  cart: Cart | null,
  meta: CartPolicyMeta,
): CartPolicyResult {
  let current = input;
  const reasons: string[] = [];
  let userMessage: string | undefined;

  for (const tagged of policies) {
    if (tagged.appliesTo && !tagged.appliesTo(meta)) continue;

    const result = tagged.policy(current, cart, meta);
    reasons.push(...result.reasons.map((r) => `${tagged.name}: ${r}`));
    if (result.userMessage) userMessage = result.userMessage;
    current = result.input;

    if (result.blocked) {
      return {
        input: current,
        blocked: true,
        blockReason: result.blockReason ?? tagged.name,
        userMessage: result.userMessage ?? userMessage,
        reasons,
      };
    }
  }

  return { input: current, reasons, userMessage };
}
